import Handlebars from "handlebars";

/**
 * Concatenates the given arguments and returns the result.
 * If the last argument is an object, it is treated as the options object.
 * The options object can have a `separator` property to specify the separator to use between the arguments.
 *
 * Usage:
 * ```handlebars
 * {{concat 'Hello' 'world' separator='-'}}
 * ```
 *
 * Output:
 * ```
 * Hello-world
 * ```
 *
 * Usage:
 * ```handlebars
 * {{concat 'Hello' 'world'}}
 * ```
 *
 * Output:
 * ```
 * Hello_world
 * ```
 *
 * @param {...*} args - The arguments to concatenate.
 * @param {Object} options - The options object.
 * @param {string} [options.separator=''] - The separator to use between the arguments.
 *
 * @returns {Handlebars.SafeString} The concatenated string
 */
Handlebars.registerHelper("concat", (...args) => {
  const options = args.pop() ?? {};
  const separator = options.separator ?? "_";

  return new Handlebars.SafeString(args.join(separator));
});
